import React, { useState } from 'react';
import maincoordiheaderStyle from './MainCoordinatorHeader.module.css';
import logo from '../../../assets/images/brandlogo.png';
import { useMediaQuery } from 'react-responsive';

export default function MainCoordinatorHeader() {

    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

    return (
        <>
            {isMobile ? (
                <header className={maincoordiheaderStyle.mobilmaincoordinatorHeader}>
                    <div className={maincoordiheaderStyle.mobilmaincoordiheaderContent}>
                        <div className='container'>
                            <nav className={`${maincoordiheaderStyle.mobilmaincoordiheaderNav} ${maincoordiheaderStyle.mobilmaincoordiheadernavExpand} flex-wrap`}>
                                <a href="/" className={`${maincoordiheaderStyle.mobilmaincoordiheaderLeft} me-auto`}>
                                    <div className={`${maincoordiheaderStyle.mobilmaincoordiheaderBrand} d-flex align-items-start`}>
                                        <img src={logo} className={`${maincoordiheaderStyle.mobilmaincoordiheaderBrandimage} img-fluid`} />
                                        <div className={maincoordiheaderStyle.mobilmaincoordiheaderbrandTitles}>
                                            <h6> AuthorMeet </h6>
                                            <p> Powered by: Bookworm Central </p>
                                        </div>
                                    </div>
                                </a>
                            </nav>
                        </div>
                    </div>
                </header>
            ) : (
                <header className={maincoordiheaderStyle.coordinatormainHeader}>
                    <div className={maincoordiheaderStyle.coordinatormainheaderContent}>
                        <div className='container'>
                            <nav className={`${maincoordiheaderStyle.coordinatormainheaderNav} ${maincoordiheaderStyle.coordinatormainheadernavExpand} flex-wrap`}>
                                <a href="https://www.authormeet.net/" >
                                    <div className={`${maincoordiheaderStyle.coordinatormainheaderLeft} me-auto`}>
                                        <div className={`${maincoordiheaderStyle.coordinatormainheaderBrand} d-flex align-items-start`}>
                                            <img src={logo} className={`${maincoordiheaderStyle.coordinatormainheaderBrandimage} img-fluid`} />
                                            <div className={maincoordiheaderStyle.coordinatormainheaderbrandTitles}>
                                                <h6> AuthorMeet </h6>
                                                <p> Powered by: Bookworm Central </p>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </nav>
                        </div>
                    </div>
                </header>
            )}
        </>
    )
}
